import "core-js/modules/es.number.constructor.js";
import AzImg from '~/components/Atoms/AzImg.vue';
import PriceDiscountLabel from '~/components/Product/ProductPrice/PriceDiscountLabel.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
export default defineComponent({
  name: 'StickyAddToCartOverlay',
  components: {
    PriceDiscountLabel: PriceDiscountLabel,
    AzButton: AzButton,
    AzImg: AzImg,
    PriceDisplay: PriceDisplay
  },
  props: {
    title: {
      type: String,
      required: true
    },
    price: {
      type: Object,
      default: function _default() {}
    },
    regularPrice: {
      type: Number,
      default: 0
    },
    specialPrice: {
      type: Number,
      default: 0
    },
    isInStock: {
      type: Boolean,
      default: false
    },
    qty: {
      type: Number,
      default: 0
    },
    productImage: {
      type: String,
      default: ''
    },
    showPrice: {
      type: Boolean,
      default: false
    },
    capacityLabel: {
      type: String,
      default: null
    }
  },
  setup: function setup() {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    return {
      translate: translate
    };
  }
});